import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';
import { DEFAULT_ICON_NAME, ICON_STYLE_DEFAULTS } from './constants';

export const icon = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.ICON> =>
	createModel({
		type: COMPONENT_TYPE.ICON,
		componentProps: {
			alt: '',
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: { [OTHER_PROPS.icon.iconName]: DEFAULT_ICON_NAME },
				},
			},
			styles: {
				[COMPONENT_STATES.DEFAULT]: { [DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: { ...ICON_STYLE_DEFAULTS } },
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.ICON>;
